/* eslint-disable import/prefer-default-export */
const getDomainName = () => {
  switch (COUNTRY) {
    case 'PL':
      return 'hapipozyczki.pl';
    case 'AU':
    case 'FI':
    case 'LV':
    case 'LT':
    case 'EE':
      return 'credit24.com';
    default:
      return 'creditea.com';
  }
};

const scriptUrl = (params) => {
  const url = `https://voto.${getDomainName()}/fp/tags.js?org_id=${params.org_id}&session_id=${params.session_id}`;
  if (COUNTRY === 'AU' && params.policy) {
    return `${url}&policy=${params.policy}`;
  }
  return url;
};

export function createTMXScript(params) {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = encodeURI(scriptUrl(params));
  document.body.appendChild(script);
}

export const invokeThreadMetrixProfiling = (params) => {
  if (window.asset81hasf) {
    window.asset81hasf.profile(`voto.${getDomainName()}`, params.org_id, params.session_id);
  }
};
